import PrivateGuard from './PrivateGuard';

export default PrivateGuard;
